module.exports = __webpack_public_path__ + "img/border_two.1307b20c.png";